import styled from 'styled-components';
import {Space} from 'antd';
import Search from '../../../Search';

const StyledTableFilters = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

const StyledTableFiltersSearch = styled(Search)`
  width: 168px;
`;

const StyledTableFiltersElements = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
`;

const StyledTableFiltersRightSideContent = styled.div`
  align-items: center;
  display: flex;
  justify-content: flex-end;
`;

const StyledTableFiltersElementsSpace = styled(Space).withConfig({
  shouldForwardProp: (prop) => !['enabledRightSideContent'].includes(prop),
})`
  width: 100%;
  overflow-x: auto;
  & > .ant-space-item {
    &:not(:first-of-type) {
      max-width: 210px;
      width: 100%;
    }
    &:nth-of-type(2),
    &:nth-of-type(3) {
      max-width: 155px;
    }
    &:last-of-type {
      margin-left: ${props => props.enabledRightSideContent ? 'auto' : 'unset'};
      margin-right: ${props => props.enabledRightSideContent ? 0 : '8px'};
    }
  }
  
  .ant-select {
    width: 100%;
    &.ant-select-lg {
      .ant-select-selector {
        &::after {
          line-height: 30px;
        }
      }
    }
    &.table-filters__cards-select {
      min-width: 264px;
    }
  }
`;

export {
  StyledTableFilters,
  StyledTableFiltersSearch,
  StyledTableFiltersElements,
  StyledTableFiltersElementsSpace,
  StyledTableFiltersRightSideContent
};
